import React from 'react';
import { CloudOff } from 'lucide-react';
import { Badge, type BadgeTone } from '../ui/Badge.js';
import type { LocalTabEditStatus, TabEditStatus } from '../../types/index.js';
import { TAB_EDIT_COPY } from '../../utils/tabEdits.js';

export interface EditStatusBadgeProps {
  status: TabEditStatus | LocalTabEditStatus;
  long?: boolean;
  className?: string;
  'data-testid'?: string;
  testId?: string;
}

export const EditStatusBadge: React.FC<EditStatusBadgeProps> = ({
  status,
  long = false,
  className = '',
  'data-testid': dataTestId,
  testId
}) => {
  let tone: BadgeTone = 'neutral';
  let hasDot = false;
  let icon: React.ReactNode = null;
  let label = '';

  switch (status) {
    case 'PENDING':
      tone = 'warning';
      hasDot = true;
      label = long ? TAB_EDIT_COPY.c22 : TAB_EDIT_COPY.c24Pending;
      break;
    case 'QUEUED':
      tone = 'neutral';
      hasDot = false;
      icon = <CloudOff className="size-3.5 shrink-0" aria-hidden="true" />;
      label = TAB_EDIT_COPY.c23;
      break;
    case 'APPROVED':
      tone = 'success';
      hasDot = true;
      label = TAB_EDIT_COPY.c24Approved;
      break;
    case 'REJECTED':
      tone = 'error';
      hasDot = true;
      label = TAB_EDIT_COPY.c24Rejected;
      break;
    case 'WITHDRAWN':
      tone = 'neutral';
      hasDot = false;
      label = TAB_EDIT_COPY.c24Withdrawn;
      break;
    default:
      label = status;
  }

  const testIdValue = dataTestId || testId || `edit-status-${status}`;

  return (
    <span data-testid={testIdValue} className="inline-flex">
      <Badge tone={tone} dot={hasDot} size="md" className={className}>
        {icon}
        <span>{label}</span>
      </Badge>
    </span>
  );
};

EditStatusBadge.displayName = 'EditStatusBadge';
